export default __webpack_public_path__ + "static/services1-9640b0e9fe81d9ae3a2f586c63485d72.png";